<div class="note-team-members-modal">
  <div class="dialog-header">
    <div class="header-title">{{ headerTitle }}</div>
    <button
      mat-mini-fab
      class="btn-dialog-close"
      mat-dialog-close
    >&times;</button>
  </div>
  <mat-divider class="header-divider"></mat-divider>
  <div class="users-autocomplete-wrapper">
    <mat-form-field color="accent">
      <mat-label>{{autocompletePlaceholder}}</mat-label>
      <input
        type="text"
        matInput
        [formControl]="searchControl"
        #autocompleteTrigger
        (input)="openAutocompletePanel()"
        [matAutocomplete]="auto"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onTeamMemberSelected($event)"
    >
      <mat-option
        *ngFor="let teamMember of teamMembersSearchResult | async"
        [value]="teamMember"
      >
        {{ teamMember.name }}
      </mat-option>
    </mat-autocomplete>
  </div>
  <div
    *ngFor="let teamMember of selectedTeamMembers; let last = last"
    class="team-members-list-item"
  >
    <common-mojo-avatar
      [id]="teamMember.photoId"
      [selectedPhotoShape]="avatarPhotoShape"
      [initials]="getInitials(teamMember)"
      [backgroundSize]="avatarBackground"
    ></common-mojo-avatar>
    {{ getName(teamMember) }}
    <mat-icon (click)="removeTeamMember(teamMember)">delete</mat-icon>
    <mat-divider
      *ngIf="!last"
      class="team-members-divider"
    ></mat-divider>
  </div>
  <button
    mat-raised-button
    color="primary"
    class="sm save-btn"
    (click)="onSave()"
  >SAVE</button>
</div>
